import { useContextSelector } from "use-context-selector";

import { SectionSizingContext } from "./SectionSizingContext";
import type { SectionSizingContextProps } from "./SectionSizingContext";

export const useSectionSizingContextSelector = <Selected>(
  selector: (context: SectionSizingContextProps) => Selected,
) => {
  return useContextSelector(SectionSizingContext, selector);
};
